// import QuestionCategory from './QuestionCategory';

export default {
  // component: QuestionCategory,
  component: load(() => import(/* webpackChunkName: "Evaluation360-QuestionCategory" */ './QuestionCategory')),
  priority: 100,
  permissions: ['360EvaluationMenu/QuestionMenu/QuestionGroupMenu'],
  name: app.translate('routes.home.evaluation-360.Question QuestionCategory'),
  icon: 'file-tree',
  drawer: true,
};
